import CreateBookTimePage from "./create-book-time.page";

export default CreateBookTimePage;
